





















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Question, Response } from '@/store/modules/survey-store-module'
import { Icon } from '@alpha/ink'
import loadingGif from '@/assets/img/loading.gif'
import QuestionResponse from './QuestionResponse.vue'
import A from '@/utilities/alpha'
import store from '@/store'
import { getQuestionOpenEnds } from '../Utilities/SurveyUtilities'
import { RespondentSurveyState } from '@alpha/shared/src/entities/RespondentSurveyEvent'

@Component({
  components: {
    Icon,
    QuestionResponse
  }
})
export default class ResponsesByQuestion extends Vue {
  @Prop({ required: true }) question!: Required<Question>
  @Prop({ required: true }) index!: number
  @Prop({ required: true }) questionsLength!: number
  @Prop({ required: true }) readonly respondentRemovalMap!: Record<string, boolean>
  @Prop({ required: true }) readonly responseRemovalMap!: Record<string, boolean>
  show: boolean = true
  loadingGif = loadingGif
  render: boolean = false

  mounted () {
    setTimeout(() => {
      this.render = true
    }, 0)
  }

  get questionTitle () {
    return A.stripHTML(this.question.text)
  }

  get responsesSelectedCount () {
    const questionResponseIds = new Set(this.questionOpenEnds!.map(response => response.id))

    return Object.entries(this.respondentRemovalMap).reduce((acc: string[], [key, val]) => {
      if (val) { // only add response ids if respondent is selected
        const responseIds = store.getters.survey.unfilteredResponsesByRespondentId(key).map(response => response.id)
        acc = acc.concat(responseIds)
      }
      return acc
    }, []).reduce((acc: number, responseId: string) => {
      if (this.responseRemovalMap[responseId] && questionResponseIds.has(responseId)) acc += 1
      return acc
    }, 0)
  }

  get questionOpenEnds (): Response[] {
    return getQuestionOpenEnds(this.question)
  }

  get isAlphaAdmin () {
    return store.state.user.authenticatedUser!.admin
  }

  nextQuestion () {
    this.$emit('scrollToNextQuestion')
  }

  previousQuestion () {
    this.$emit('scrollToPreviousQuestion')
  }

  toggleResponseRemoval (payload: { response: Response, shiftClick: boolean }, index: number) {
    this.$emit('toggleResponseRemoval', Object.assign(payload, { index }))
  }

  canToggleResponse (response: Response) {
    if (this.isAlphaAdmin) return true
    return response.status !== RespondentSurveyState.REJECTED_BY_DS
  }

  toggleAllResponses () {
    this.show = !this.show
    const responseIds = this.question!.responses!.filter(this.canToggleResponse).map((response: Response) => response.id)
    this.$emit('setAllResponses', responseIds, this.show)
  }
}
